import { render, staticRenderFns } from "./attachSource.vue?vue&type=template&id=620e7cb3&v-on-clickaway=cancel&"
import script from "./attachSource.vue?vue&type=script&lang=ts&"
export * from "./attachSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports